import React, { useState, useEffect, Fragment, useRef } from "react";
import "antd/dist/antd.css";
import "./SCB.css";
import { useLocation, useSearchParams } from "react-router-dom";
import { get, orderBy, debounce } from "lodash";
import { BsArrowLeft } from "react-icons/bs";
import {
  Alert,
  Form,
  Input,
  Button,
  Spin,
  PageHeader,
  Layout,
  Space,
  Result,
  Image,
  Typography,
  Select,
  Radio,
  AutoComplete,
  DatePicker,
  Checkbox,
  Collapse,
  Popover,
  Steps,
  Modal,
} from "antd";
import {
  LoadingOutlined,
  MinusOutlined,
  PlusOutlined,
  CheckCircleFilled,
  CloseCircleFilled,
  ExclamationCircleFilled,
} from "@ant-design/icons";
import moment from "moment";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";

import { Formik, Field } from "formik";

import * as yup from "yup";

import { onecodeAPI } from "../AppConfig";
import brandIcon from "./Standard_Chatered.jpg";
import FloatLabel from "../Components/FloatingLabel";
import InputComponent from "../Components/DynamicForm/InputComponent";
import SelectComponent from "../Components/DynamicForm/SelectComponent";
import DateComponent from "../Components/DynamicForm/DateComponent";
import DyanamicSelectBox from "../Components/DynamicForm/DyanamicSelectBox";
import {
  createYupSchema,
  cloneData,
} from "../Components/DynamicForm/validation";
import CheckboxComponent from "../Components/DynamicForm/CheckboxComponent";
import { isCharWithoutSymbol, isNumber } from "../utils/regexConstants";
import mixpanel from "mixpanel-browser";
import ApplicationStatusBody from "../Components/ApplicationStatusBody";

const steps = ["Personal", "Employment", "Declaration"];
const stepIds = [108, 109, 110];

const { Text, Link } = Typography;

const antIcon = (
  <LoadingOutlined
    style={{ fontSize: 18, color: "#fff", marginRight: 10 }}
    spin
  />
);

const localizationCode = "en";

export default function SCBForm() {
  const [hash, setHash] = useState();
  const [formData, setFormData] = useState({});
  const [formValidations, setFormValidations] = useState({});
  const [formValues, setFormValues] = useState({});
  const [preFormValues, setPreFormValues] = useState([]);

  const [loading, setLoading] = useState(true);
  const [activeStep, setActiveStep] = React.useState(0);
  const [personalData, setPersonalData] = React.useState({});
  const [employeementData, setEmployeementData] = React.useState({});
  const [declarationData, setDeclarationData] = React.useState({});
  const [saving, setSaving] = useState(false);
  const [applicationStatus, setApplicationStatus] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [partner, setPartner] = useState();

  const partnerId = useRef();
  const partnerName = useRef();

  const handleStep = (step) => {
    setActiveStep(step);
  };

  useEffect(() => {
    try {
      let params = new URLSearchParams(window.location.search);

      if (params.get("hash")) {
        setHash(encodeURIComponent(params.get("hash")));
      }
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    if (hash) {
      getFieldsByPartner();
    } else {
      setLoading(false);
    }
  }, [hash]);

  // useEffect(() => {
  //   if (phoneNumber) {
  //     mixpanel.track("screen_view", {
        
  //       lead_phone_number: phoneNumber,
  //     });
  //   }
  // }, [phoneNumber]);

  // React.useEffect(() => {
  //   if (activeStep) {
      
  //   }
  // }, [activeStep]);

  const getFieldsByPartner = async () => {
    setLoading(true);
    let mobileNumber = null;
    let preFormValuesData = [];
    let partnerName = null;
    try {
      const scbAutoFill = await onecodeAPI.post(`/public/AutoFillCC`, {
        hash: hash,
      });
      if (
        scbAutoFill.data &&
        scbAutoFill.data.body &&
        Array.isArray(scbAutoFill.data.body)
      ) {
        preFormValuesData = scbAutoFill.data.body;
        setPreFormValues(scbAutoFill.data.body);
        if (preFormValuesData.length > 0) {
          const preData = preFormValuesData.filter(
            (pre) => pre.fieldCode == "Mobile"
          );
          if (preData.length > 0) {
            mobileNumber = preData[0].fieldValue;
            setPhoneNumber(mobileNumber);
          }
        }
      }
    } catch (error) {
      console.log(error);
    }

    try {
      const res = await onecodeAPI.post(`/partnerForm/partnerForm/v5`, {
        hash: hash,
        locale: "en",
      });
      // console.log(res);
      if (res && res.data) {
       const result = processFormData(res.data, preFormValuesData);
       partnerId.current = result._partnerId;
       partnerName.current = result._partnerName;
       mixpanel.track("screen_name", {
        screen_name: "scb-form",
        lead_phone_number: phoneNumber,
        page_name: steps[activeStep],
        page_number: activeStep,
        partner_id: partnerId.current,
        partner_name: partnerName.current,
      });
      }
      // processFormData(jsonData.data.data);
    } catch (error) {
      setLoading(false);
      console.log("errror-customer", error);
    }
  };

  const processFormData = (data, preFormValuesData) => {
    let processedData = {};
    let validationData = {};
    let partnerData = null;
    let formValuesData = {};

    if (data.partnerForms && data.partnerForms.length > 0) {
      const ocForm = data.partnerForms[0].ocForm;
      if (ocForm && ocForm.ocFieldGroups && ocForm.ocFieldGroups.length > 0) {
        ocForm.ocFieldGroups.map((ocFieldGroup) => {
          if (ocFieldGroup && ocFieldGroup.ocFields) {
            const orderData = orderBy(
              ocFieldGroup.ocFields,
              ["orderNo"],
              ["asc"]
            );

            partnerData = data.partnerForms[0].partner;

            processedData = {
              ...processedData,
              [ocFieldGroup.id]: orderData,
            };

            let ocFieldGroupData = {};
            orderData.map((field) => {
              let preValue = "";

              let initPreValue = "";
              if (preFormValuesData.length > 0) {
                const preData = preFormValuesData.filter(
                  (pre) => pre.fieldId == field.id
                );
                if (preData.length > 0) {
                  preValue =
                    preData[0].optionId &&
                    (field.type == "dropdown" || field.type == "search")
                      ? preData[0].optionId
                      : preData[0].optionValue
                      ? preData[0].optionValue
                      : preData[0].fieldValue;
                  if ("OtherCompanyName" == field.code && preValue != "") {
                    initPreValue = preData[0].fieldValue;
                  }
                }
              }

              if (
                !preValue &&
                preValue == "" &&
                field.code == "ResidentialStatus"
              ) {
                if (field.fieldOptions && field.fieldOptions.length > 0) {
                  preValue = field.fieldOptions[0].optionId;
                }
              }

              if (!preValue && preValue == "" && field.code == "EmpType") {
                if (field.fieldOptions && field.fieldOptions.length > 0) {
                  preValue = field.fieldOptions[0].optionId;
                }
              }

              if (field.type == "date selector") {
                try {
                  const checkData = moment(preValue, "DD/MM/YYYY");
                  if (!checkData.isValid()) {
                    preValue = "";
                  }
                } catch (error) {}
              }

              // if (field.id == 537) {
              //   preValue = "7337";
              // }

              if ("CompanyCode" == field.code && preValue == "") {
                const otherCompanyNamePreData = preFormValuesData.filter(
                  (pre) => pre.fieldCode == "OtherCompanyName"
                );

                if (
                  otherCompanyNamePreData &&
                  otherCompanyNamePreData.length > 0
                ) {
                  preValue = otherCompanyNamePreData[0].optionId
                    ? otherCompanyNamePreData[0].optionId
                    : "";
                }
              }

              let initfieldData = {
                [field.id]: preValue ? preValue : "",
              };

              if ("OtherCompanyName" == field.code && preValue != "") {
                initfieldData = {
                  ...initfieldData,
                  [`${field.id}_name_`]: initPreValue,
                };
              }

              // OtherCompanyName

              ocFieldGroupData = {
                ...ocFieldGroupData,
                ...initfieldData,
              };
            });

            formValuesData = {
              ...formValuesData,
              [ocFieldGroup.id]: ocFieldGroupData,
            };

            const yepSchema = orderData.reduce(createYupSchema, {});

            validationData = {
              ...validationData,
              [ocFieldGroup.id]: yup.object().shape(yepSchema),
            };
          }
        });
      }
    }
    setFormData(processedData);
    setFormValidations(validationData);
    setFormValues(formValuesData);
    setLoading(false);
    setPartner(partnerData);
    return {_partnerId: partnerData?.id,_partnerName: data.partnerForms[0].partnerName }
  };

  const savePersonalData = (data) => {
    // console.log("Personal data" + JSON.stringify(data));
    // setPersonalData(data);
    autoSaveApplication({ [stepIds[activeStep]]: data }, stepIds[activeStep]);
    setFormValues({ ...formValues, [stepIds[activeStep]]: data });
    handleStep(activeStep + 1);
  };

  const saveEmployeementData = (data) => {
    // console.log("Employeement data" + JSON.stringify(data));
    // setEmployeementData(data);
    autoSaveApplication({ [stepIds[activeStep]]: data }, stepIds[activeStep]);
    setFormValues({ ...formValues, [stepIds[activeStep]]: data });
    handleStep(activeStep + 1);
  };

  const saveDeclarationData = (data) => {
    // console.log("Declaration data" + JSON.stringify(data));
    // setDeclarationData(data);
    const finalData = { ...formValues, [stepIds[activeStep]]: data };
    setFormValues(finalData);
    saveApplication(finalData);
  };

  const buildSubmitfield = (item, key, cloneData, finalData) => {
    if (
      (cloneData && item.code && item.code == "PermAddress1") ||
      item.code == "PermAddress2" ||
      item.code == "PermAddress4" ||
      item.code == "PermCity" ||
      item.code == "PermPin"
    ) {
      const keyFormData = formData[key];
      let value = "";
      if (item.code == "PermAddress1") {
        const dependedField = keyFormData.filter(
          (formItem) => formItem.code == "ResAddress1"
        );
        if (dependedField && dependedField.length > 0) {
          value = finalData[key][`${dependedField[0].id}`];
        }
      }
      if (item.code == "PermAddress2") {
        const dependedField = keyFormData.filter(
          (formItem) => formItem.code == "ResAddress2"
        );
        if (dependedField && dependedField.length > 0) {
          value = finalData[key][`${dependedField[0].id}`];
        }
      }

      if (item.code == "PermAddress4") {
        const dependedField = keyFormData.filter(
          (formItem) => formItem.code == "ResAddress4"
        );
        if (dependedField && dependedField.length > 0) {
          value = finalData[key][`${dependedField[0].id}`];
        }
      }
      if (item.code == "PermCity") {
        const dependedField = keyFormData.filter(
          (formItem) => formItem.code == "ResCity"
        );
        if (dependedField && dependedField.length > 0) {
          value = finalData[key][`${dependedField[0].id}`];
        }
      }

      if (item.code == "PermPin") {
        const dependedField = keyFormData.filter(
          (formItem) => formItem.code == "ResPIN"
        );
        if (dependedField && dependedField.length > 0) {
          value = finalData[key][`${dependedField[0].id}`];
        }
      }

      return {
        fieldValue: value,
        fieldId: item.id,
        fieldTitle: item.name,
        fieldCode: item.code,
      };
    } else if (item.code == "OtherCompanyName") {
      const itemValue = finalData[key][`${item.id}_name_`]
        ? finalData[key][`${item.id}_name_`]
        : finalData[key][`${item.id}`];

      let newItemValue = finalData[key][`manualOtherCompanyName`];

      return {
        fieldValue:
          finalData[key][`${item.id}`] === "Others" ? newItemValue : itemValue,
        fieldId: item.id,
        fieldTitle: item.name,
        fieldCode: item.code,
      };
    } else if (item.code == "PermAddrSameAsResAddr") {
      return {
        fieldValue: finalData[key][`${item.id}`] ? "yes" : "no",
        fieldId: item.id,
        fieldTitle: item.name,
        fieldCode: item.code,
      };
    } else if (finalData && finalData[key] && finalData[key][`${item.id}`]) {
      return {
        fieldValue: finalData[key][`${item.id}`],
        fieldId: item.id,
        fieldTitle: item.name,
        fieldCode: item.code,
      };
    }
    return null;
  };

  const autoSaveApplication = async (finalData, key) => {
    try {
      // setSaving(true);
      const fields = [];

      let cloneData = false;
      formData[key].map((item) => {
        const keyFormData = formData[key];

        if (item.code == "PermAddrSameAsResAddr") {
          const dependedField = keyFormData.filter(
            (formItem) => formItem.code == "PermAddrSameAsResAddr"
          );
          if (dependedField && dependedField.length > 0) {
            if (finalData[key][`${dependedField[0].id}`]) {
              cloneData = true;
            }
          }
        }
      });

      formData[key].map((item) => {
        const buildData = buildSubmitfield(item, key, cloneData, finalData);
        if (buildData) {
          fields.push(buildData);
        }
      });

      const requestData = fields;

      // const requestData = {
      //   ocFieldValueDto: fields,
      // };

      // console.log("fields", fields);

      onecodeAPI.post(`public/autoSave`, requestData, {
        headers: {
          hash: hash,
        },
      });
    } catch (error) {
      console.log("saveApplication", error);
    }
    // setSaving(false);
  };

  const saveApplication = async (finalData) => {
    try {
      setSaving(true);
      const fields = [];

      let cloneData = false;
      Object.keys(formData).map(function (key) {
        formData[key].map((item) => {
          const keyFormData = formData[key];

          if (item.code == "PermAddrSameAsResAddr") {
            const dependedField = keyFormData.filter(
              (formItem) => formItem.code == "PermAddrSameAsResAddr"
            );
            if (dependedField && dependedField.length > 0) {
              if (finalData[key][`${dependedField[0].id}`]) {
                cloneData = true;
              }
            }
          }
        });
      });

      Object.keys(formData).map(function (key) {
        formData[key].map((item) => {
          const buildData = buildSubmitfield(item, key, cloneData, finalData);
          if (buildData) {
            fields.push(buildData);
          }
        });
      });

      // const requestData = {
      //   ocFieldValueDto: fields,
      // };

      const requestData = fields;

      // console.log("requestData : " + JSON.stringify(requestData));

      const res = await onecodeAPI.post(`public/submitCCLead`, requestData, {
        headers: {
          hash: hash,
        },
      });
      setApplicationStatus(res.data.data);
      mixpanel.track("screen_view", {
        screen_name: "scb_form_popup",
        reason: res.data.data.reason,
        customer_id: res.data.data.customerId,
        lead_id: res.data.data.leadId,
        status: res.data.data.status,
        partner_id: partnerId.current,
        partner_name: partnerName.current,
      });
    } catch (error) {
      console.log("saveApplication", error);
    }
    setSaving(false);
  };

  const editApplicationForm = () => {
    mixpanel.track("click_action", {
      cta_name: "scb_edit_application",
      lead_phone_number: phoneNumber,
      reason: applicationStatus.reason,
      customer_id: applicationStatus.customerId,
      lead_id: applicationStatus.leadId,
      status: applicationStatus.status,
      partner_id: partnerId.current,
      partner_name: partnerName.current,
    });
    setActiveStep(0);
    getFieldsByPartner();
    setApplicationStatus(null);
  };

  React.useEffect(() => {
    window.scroll({ top: 0 });
  }, [activeStep]);
  if (!hash) {
    return (
      <div>
        <Result
          status="404"
          title="404"
          subTitle="Sorry, the page you visited does not exist."
        />
      </div>
    );
  }
  if (loading) {
    return (
      <Spin
        spinning={loading}
        tip="Loading"
        size="large"
        style={{ fontSize: "20px", maxHeight: "100vh" }}
      >
        <div style={{ height: "100vh", width: "100%" }}></div>
      </Spin>
    );
  }

  return (
    !(partner?.isOnHold || partner?.isActive) ? (
    <Spin
      spinning={saving}
      tip="Eligibility Check"
      size="large"
      style={{ fontSize: "20px", maxHeight: "100vh" }}
    >
      <div style={{ height: "100vh", width: "100%" }}>
        <div style={{ paddingBottom: 20 }}>
          <div
            className="header"
            style={{
              boxShadow: "0px 0.5px 8px 2px rgba(0, 0, 0, 0.05)",
              // marginBottom: "20px",
              padding: "30px 20px",
              display: "flex",
              marginBottom: 20,
            }}
          >
            {activeStep > 0 ? (
              <div style={{ width: "15%", paddingTop: "1.7%" }}>
                <BsArrowLeft
                  onClick={() => {
                    mixpanel.track("back_button", {
                      screen_name: "scb_form_back",
                      lead_phone_number: phoneNumber,
                      page_number: activeStep + 1,
                      page_name: steps[activeStep],
                      partner_id: partnerId.current,
                      partner_name: partnerName.current,
                    });
                    handleStep(activeStep - 1);
                  }}
                  style={{
                    fontWeight: "bold",
                    fontSize: 20,
                  }}
                />
              </div>
            ) : null}
            <div
              style={{
                textAlign: "start",
                fontWeight: "700",
              }}
            >
              Credit Card Application
            </div>
            <div style={{ width: "30%" }}>
              <img
                src={brandIcon}
                style={{ width: "100%", objectFit: "contain" }}
              />
            </div>
          </div>

          {applicationStatus && applicationStatus.status ? (
            <ApplicationStatus
              applicationStatus={applicationStatus}
              editApplicationForm={editApplicationForm}
            />
          ) : (
            <>
              <Stepper activeStep={activeStep} alternativeLabel>
                {steps.map((label, index) => (
                  <Step key={label} completed={false}>
                    <StepButton color="inherit">{label}</StepButton>
                  </Step>
                ))}
              </Stepper>
              <div
                style={{
                  backgroundColor: "#F5F5F5",
                  borderRadius: 10,
                  margin: 15,
                  padding: 5,
                  borderWidth: "1px",
                  borderColor: "#DBDBDB",
                  borderStyle: "solid",
                }}
              >
                {activeStep === 0 ? (
                  <DynamicForm
                    submitData={savePersonalData}
                    formData={formData[stepIds[activeStep]]}
                    formValidations={formValidations[stepIds[activeStep]]}
                    personalData={formValues[stepIds[activeStep]]}
                    hash={hash}
                    position={activeStep}
                    submitButtonText="Continue"
                    preFormValues={preFormValues}
                    phone={phoneNumber}
                  />
                ) : null}
                {activeStep === 1 ? (
                  <DynamicForm
                    submitData={saveEmployeementData}
                    formData={formData[stepIds[activeStep]]}
                    formValidations={formValidations[stepIds[activeStep]]}
                    personalData={formValues[stepIds[activeStep]]}
                    hash={hash}
                    position={activeStep}
                    submitButtonText="Continue"
                    preFormValues={preFormValues}
                    phone={phoneNumber}
                  />
                ) : null}

                {activeStep === 2 ? (
                  <DynamicForm
                    submitData={saveDeclarationData}
                    formData={formData[stepIds[activeStep]]}
                    formValidations={formValidations[stepIds[activeStep]]}
                    personalData={formValues[stepIds[activeStep]]}
                    hash={hash}
                    position={activeStep}
                    submitButtonText="Submit"
                    preFormValues={preFormValues}
                    phone={phoneNumber}
                  />
                ) : null}
              </div>
            </>
          )}
        </div>
      </div>
    </Spin> ) :
    (<ApplicationStatus
      applicationStatus={{
        icon: "grey_exclamation",
        message:
          "Please try again later",
        status: "On Hold",
      }}
    /> )
  );
}

const requiredValidate = (value, name, type) => {
  let errorMessage;

  if (value == "" || !value) {
    let prefix = "Enter";
    if (type == "dropdown" || type == "search") {
      prefix = "Select";
    }

    errorMessage = `* Please ${prefix} ${name ? name : "Data"}`;
  } else if (
    (type === "text" || type === "search") &&
    !isCharWithoutSymbol.test(value)
  ) {
    errorMessage = `Special characters not allowed`;
  } else if (type === "number" && !isNumber.test(value)) {
    errorMessage = `Invalid Number`;
  }

  return errorMessage;
};

const DynamicForm = ({
  submitData,
  formData,
  personalData,
  formValidations,
  hash,
  submitButtonText,
  preFormValues,
  position,
  phone,
}) => {
  // console.log(formData);
  const [form] = Form.useForm();
  const [formSubmitLoading, setFormSubmitLoading] = useState(false);

  const onSubmit = (value) => {
    // console.log(value);
    submitData(value);
  };

  return (
    <Formik
      initialValues={{ ...personalData }}
      validationSchema={formValidations}
      onSubmit={onSubmit}
      validateOnBlur={true}
      validateOnChange={true}
      validateOnMount={true}
      enableReinitialize
    >
      {(formikData) => {
        const {
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          errors,
          isValid,
          touched,
          setValues,
          setTouched,
          resetForm,
          setFieldValue,
          dirty,
        } = formikData;
        // console.log(errors);
        // console.log(touched);

        // console.log(formikData);

        return (
          <Form
            form={form}
            name="control-hooks"
            style={{ padding: "10px" }}
            initialValues={{
              ...personalData,
            }}
          >
            {formData &&
              formData.map((formItem) => {
                const id = `${formItem.id}`;
                const marginBottom = touched[id] && errors[id] ? 0 : 20;

                let addManualField = false;
                let manualFieldData = {};

                if (formItem.code == "OtherCompanyName") {
                  const dependedField = formData.filter(
                    (fi) => fi.code == "OtherCompanyName"
                  );
                  if (dependedField && dependedField.length > 0) {
                    if (values[`${dependedField[0].id}`] === "Others") {
                      addManualField = true;
                      manualFieldData = {
                        name: "Other Company Name",
                        code: "manualOtherCompanyName",
                        id: "manualOtherCompanyName",
                        type: "text",
                      };
                    }
                  }
                }

                return (
                  <Fragment key={id}>
                    <div style={{ marginBottom: marginBottom }}>
                      <div style={{ position: "relative" }}>
                        <CustomComponent
                          formItem={formItem}
                          id={id}
                          formData={formData}
                          hash={hash}
                          values={values}
                          preFormValues={preFormValues}
                          errors={errors}
                        />
                        {(touched[id] || values[id]) && errors[id] && (
                          <ErrorComponent message={errors[id]} />
                        )}
                      </div>
                    </div>
                    {addManualField ? (
                      <div style={{ marginBottom: marginBottom }}>
                        <div style={{ position: "relative" }}>
                          <CustomComponent
                            formItem={manualFieldData}
                            id={manualFieldData.id}
                            formData={formData}
                            hash={hash}
                            values={values}
                            preFormValues={preFormValues}
                            errors={errors}
                          />
                          {(touched[manualFieldData.id] ||
                            values[manualFieldData.id]) &&
                            errors[manualFieldData.id] && (
                              <ErrorComponent
                                message={errors[manualFieldData.id]}
                              />
                            )}
                        </div>
                      </div>
                    ) : null}
                  </Fragment>
                );
              })}

            {/* {Object.keys(errors).length > 0 ? (
              <p
                style={{
                  color: "red",
                  fontSize: 14,
                  textAlign: "left",
                  position: "relative",
                  marginBottom: 1,
                  marginBottom: 5,
                }}
              >
                * Please fill all required fields
              </p>
            ) : null} */}
            <Button
              // disabled={!isValid}
              type="primary"
              // htmlType="submit"
              block
              style={{
                backgroundColor: isValid ? "#6C63FF" : "#d9d9d9",
                borderRadius: 6,
                height: 45,
                borderColor: isValid ? "#6C63FF" : "#d9d9d9",
                fontWeight: "bold",
                fontSize: 16,
              }}
              onClick={() => {
                if (isValid) {
                  handleSubmit();
                  mixpanel.track("click_action", {
                    item_name: "scb_form_cta",
                    cta_name: submitButtonText,
                    page_number: position + 1,
                    page_name: steps[position],
                    lead_phone_number: phone,
                  });
                }
              }}
            >
              {formSubmitLoading && <Spin indicator={antIcon} />}
              <Text style={{ color: "#fff" }}> {submitButtonText}</Text>
            </Button>
          </Form>
        );
      }}
    </Formik>
  );
};

let customError = {};
const CustomComponent = (props) => {
  const { formItem, id, formData, hash, values, preFormValues, errors } = props;

  const code = formItem.code;
  let isValidationRequired = false;
  let isValidationRequiredData = "";

  let readOnly = false;
  let hide = false;

  if (
    code == "CompanyCode" ||
    code == "Mobile" ||
    code == "ResidentialStatus" ||
    code == "PAN" ||
    code == "EmpType"
  ) {
    readOnly = true;
  }

  if (code == "Mobile" || code == "PAN") {
    if (preFormValues.length > 0) {
      const preData = preFormValues.filter((pre) => pre.fieldCode == code);
      if (preData.length > 0) {
        let fieldData = preData[0].fieldValue;
        if (!fieldData) {
          readOnly = false;
        }
      }
    } else {
      readOnly = false;
    }
  }

  if (readOnly) {
    if (errors[id]) {
      customError = { ...customError, [id]: errors[id] };
    }
    if (customError[id]) {
      readOnly = false;
    }
  }

  if (
    code == "PermAddress1" ||
    code == "PermAddress2" ||
    code == "PermAddress4" ||
    code == "PermCity" ||
    code == "PermPin"
  ) {
    const dependedField = formData.filter(
      (formItem) => formItem.code == "PermAddrSameAsResAddr"
    );
    if (dependedField && dependedField.length > 0) {
      if (values[`${dependedField[0].id}`]) {
        readOnly = true;
      }
    }
  }

  if (code == "CustReltnType") {
    const dependedField = formData.filter(
      (formItem) => formItem.code == "IsExtngScbCust"
    );
    if (dependedField && dependedField.length > 0) {
      if (
        values[`${dependedField[0].id}`] == "yes" ||
        values[`${dependedField[0].id}`] == true
      ) {
        isValidationRequired = true;
        isValidationRequiredData = formItem.name;
      } else {
        readOnly = true;
      }
    }
  }

  // if (code == "SalaryBankAcc" || code == "GMI" || code == "TotalWorkExp") {
  //   const dependedField = formData.filter(
  //     (formItem) => formItem.code == "EmpType"
  //   );
  //   if (dependedField && dependedField.length > 0) {
  //     // console.log("GMI " + values[`${dependedField[0].id}`]);
  //     if (values[`${dependedField[0].id}`] == "1") {
  //       isValidationRequired = true;
  //       isValidationRequiredData = formItem.name;
  //     } else {
  //       hide = true;
  //     }
  //   }
  // }

  if (code == "OtherDocExpDate") {
    isValidationRequired = true;
    const dependedField = formData.filter(
      (formItem) => formItem.code == "OtherDocType"
    );
    if (dependedField && dependedField.length > 0) {
      // console.log("GMI " + values[`${dependedField[0].id}`]);
      if (values[`${dependedField[0].id}`] == "voterId") {
        isValidationRequired = false;
      }
    }
  }
  if (code == "manualOtherCompanyName") {
    isValidationRequired = true;
    isValidationRequiredData = formItem.name;
  }

  if (hide) {
    return null;
  }

  if (formItem.type && (formItem.type == "text" || formItem.type == "number")) {
    return (
      <Field
        name={id}
        component={InputComponent}
        placeholder={formItem.name}
        item={formItem}
        validate={
          isValidationRequired
            ? (value) =>
                requiredValidate(value, isValidationRequiredData, formItem.type)
            : null
        }
        readOnly={readOnly}
        formData={formData}
        keyboardType={formItem.type == "number" ? "numeric" : "text"}
      />
    );
  } else if (
    formItem.type &&
    formItem.type == "dropdown" &&
    formItem.fieldOptions &&
    formItem.fieldOptions.length > 0
  ) {
    return (
      <Field
        name={id}
        component={SelectComponent}
        placeholder={formItem.name}
        item={formItem}
        validate={
          isValidationRequired
            ? (value) =>
                requiredValidate(value, isValidationRequiredData, formItem.type)
            : null
        }
        formData={formData}
        search={"Occupation" == code || "IndustryIsic" == code ? true : false}
        readOnly={readOnly}
      />
    );
  } else if (formItem.type && formItem.type == "date selector") {
    return (
      <Field
        name={id}
        component={DateComponent}
        placeholder={formItem.name}
        item={formItem}
        formData={formData}
        validate={
          isValidationRequired
            ? (value) =>
                requiredValidate(value, isValidationRequiredData, formItem.type)
            : null
        }
      />
    );
  } else if (formItem.type && formItem.type == "search") {
    return (
      <Field
        name={id}
        component={DyanamicSelectBox}
        placeholder={formItem.name}
        item={formItem}
        formData={formData}
        hash={hash}
        validate={
          isValidationRequired
            ? (value) =>
                requiredValidate(value, isValidationRequiredData, formItem.type)
            : null
        }
        preFormValues={preFormValues}
      />
    );
  } else if (formItem.type && formItem.type == "checkbox") {
    return (
      <Field
        name={id}
        component={CheckboxComponent}
        placeholder={formItem.name}
        item={formItem}
        validate={
          isValidationRequired
            ? (value) =>
                requiredValidate(value, isValidationRequiredData, formItem.type)
            : null
        }
        formData={formData}
        hash={hash}
      />
    );
  }
  return null;
};

const ErrorComponent = ({ message }) => {
  return (
    <p
      style={{
        color: "red",
        fontSize: 12,
        textAlign: "left",
        position: "relative",
        marginTop: 1,
        marginBottom: 10,
        lineHeight: 1,
        paddingLeft: 2,
      }}
    >
      {message}
    </p>
  );
};

const ApplicationStatus = ({ applicationStatus, editApplicationForm }) => {
  const [isModalVisible, setIsModalVisible] = useState(true);

  React.useEffect(() => {
    if (applicationStatus) {
      setIsModalVisible(true);
    }
  }, [applicationStatus]);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    // setIsModalVisible(false);
  };

  const handleCancel = () => {
    // setIsModalVisible(false);
  };

// return (
  //   <Modal
  //     title=""
  //     visible={isModalVisible}
  //     onOk={handleOk}
  //     onCancel={handleCancel}
  //     footer={null}
  //     closable={false}
  //     centered
  //   >
  //     <div
  //       style={{
  //         display: "flex",
  //         justifyContent: "center",
  //         alignItems: "center",
  //         textAlign: "center",
  //         flexDirection: "column",
  //         paddingTop: 10,
  //         paddingBottom: 10,
  //       }}
  //     >
  //       <div
  //         style={{
  //           width: "100%",
  //         }}
  //       >
  //         {applicationStatus.icon ? (
  //           "tick" == applicationStatus.icon.toLowerCase() ? (
  //             <CheckCircleFilled
  //               style={{ fontSize: 36, color: "#00C34E", margin: 10 }}
  //             />
  //           ) : "cross" == applicationStatus.icon.toLowerCase() ? (
  //             <CloseCircleFilled
  //               style={{ fontSize: 36, color: "#D10000", margin: 10 }}
  //             />
  //           ) : "exclamation" == applicationStatus.icon.toLowerCase() ? (
  //             <ExclamationCircleFilled
  //               style={{ fontSize: 36, color: "#D17100", margin: 10 }}
  //             />
  //           ) : null
  //         ) : null}

  //         <p style={{ fontWeight: "bold" }}>{applicationStatus.status}</p>
  //         {applicationStatus.reason ? (
  //           <div
  //             style={{
  //               backgroundColor: "#E9E9E9",
  //               padding: 15,
  //               borderRadius: 10,
  //             }}
  //           >
  //             {applicationStatus.reason}
  //           </div>
  //         ) : null}
  //         {applicationStatus.isEditAllowed ? (
  //           <Button
  //             type="primary"
  //             htmlType="submit"
  //             block
  //             style={{
  //               backgroundColor: "#6C63FF",
  //               borderRadius: 6,
  //               height: 45,
  //               marginTop: 10,
  //               fontWeight: "bold",
  //               fontSize: 16,
  //             }}
  //             onClick={() => {
  //               editApplicationForm();
  //             }}
  //           >
  //             <Text style={{ color: "#fff" }}>Edit Application Form</Text>
  //           </Button>
  //         ) : null}
  //       </div>
  //     </div>
  //   </Modal>
  // );

  return (
    <Modal
      title=""
      visible={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={null}
      closable={false}
      centered
      style={{ paddingLeft: 10, paddingRight: 20 }}
    >
      <ApplicationStatusBody
        applicationStatus={applicationStatus}
        editApplicationForm={editApplicationForm}
      />
    </Modal>
  );
};
